// extracted by mini-css-extract-plugin
module.exports = {"button":"career-motivation-button_component_button__tXaX8","small":"career-motivation-button_component_small__juad7"};